// import hooks
import useTableContext from 'components/admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import components
import { Button } from '@mui/material';
import BackToListButton from './BackToListButton';
import InnerViewNavigator from './InnerViewNavigator';

// import styles
import {
  StyledToolbarContentBox,
  StyledToolbarMainBox
} from './ToolbarContent.styles';

// import types
import type { FC } from 'react';
import type { ToolbarContentProps } from './ToolbarContent.types';

// import utils
import { createPortal } from 'react-dom';

const ToolbarContent: FC<ToolbarContentProps> = ({
  setIsInEditMode,
  isInEditMode,
  toggleInnerLayout,
  currentView,
  setCurrentView,
  views,
  navigatorLabelGetter,
  navigatorValueGetter
}) => {
  'use memo';

  const { contentNodeForButtons } = useTableContext();
  const [loaded, setLoaded] = useState<boolean>(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (contentNodeForButtons?.current) setLoaded(true);
  }, [contentNodeForButtons]);

  return loaded
    ? createPortal(
        <StyledToolbarContentBox>
          <StyledToolbarMainBox>
            <InnerViewNavigator
              currentView={currentView}
              setCurrentView={setCurrentView}
              views={views}
              navigatorLabelGetter={navigatorLabelGetter}
              navigatorValueGetter={navigatorValueGetter}
            />
            <BackToListButton closeInnerView={toggleInnerLayout} />
          </StyledToolbarMainBox>
          {!isInEditMode && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsInEditMode(true)}
            >
              {t('edit')}
            </Button>
          )}
        </StyledToolbarContentBox>,
        contentNodeForButtons.current as HTMLDivElement
      )
    : null;
};

export default ToolbarContent;
